import { Pressable } from '@react-aria/interactions'
import Styles from './ReplaceableOverlay.module.scss'
import { ImageAdd } from 'blaze-ui/icons'
import { observer } from 'mobx-react-lite'
import { TLShapeId, track, useReadonly } from '@tldraw/tldraw'
import { useEditor } from 'components/VisualStudioPlayground/VisualEditorContext'
import { useReplaceImage } from 'components/Design/ShapesTab/components/useReplaceImage'
import { ImageShape } from './Types'
import { MaskShape } from '../MaskShape/Types'
import { getIsPreview } from 'components/VisualStudioPlayground/VisualEditor/helpers'

interface Props {
  shapeId: TLShapeId
}

const ReplaceableOverlayContainer = track(
  observer(({ shapeId }: Props) => {
    const editor = useEditor()
    const shape = editor.getShape(shapeId)
    const isReadonly = useReadonly()
    const isPreview = getIsPreview(editor)

    if (!shape || isReadonly || isPreview) {
      return null
    }

    return <ReplaceableOverlay shape={shape as ImageShape | MaskShape} />
  }),
)

const ReplaceableOverlay = track(
  observer(({ shape }: { shape: ImageShape | MaskShape }) => {
    const editor = useEditor()
    const { replace } = useReplaceImage({ editor, selectedShape: shape })

    const handlePress = () => {
      replace()
    }

    return (
      <Pressable onPress={handlePress}>
        <div className={Styles.replaceableOverlay}>
          <div className={Styles.button}>
            <ImageAdd size={16} />
            <div>Replace</div>
          </div>
        </div>
      </Pressable>
    )
  }),
)

export { ReplaceableOverlayContainer as ReplaceableOverlay }
